import { Button } from "iparque-components";
import styled from "styled-components";

const FormButton = styled(Button)`
  width: 100%;
  margin-top: 30px;
  padding: 0.8rem 4.5rem;
  text-transform: uppercase;
`;

export default FormButton;
